import React, { useEffect, useState } from "react";
import { Btn } from "../../../AbstractElements";
import { useGetOrgUnitsData } from "../../Employee/hooks/useEmployee";
import ReusableDropdown from "../../../Component/BasicComponents/Dropdowns/RouteDropdown";
import { useAddPriceBook, useUpdatePriceBook } from "../usePriceBook";


interface PricebookModalContentProps {
  handleSubmit?: (e: React.FormEvent) => void;
  handleClose: () => void;
  priceBookRow?:any;
  chechStatusSubmitAndUpdate?: string;
}

interface formInterface {
  orgUnit:any,
  name:string,
  description:string
}

const PriceBooksModalContent: React.FC<PricebookModalContentProps> = ({handleClose,priceBookRow,chechStatusSubmitAndUpdate}) => {

  // console.log('priceBookRow',priceBookRow);
  
  const [formData,setFormData] = useState<formInterface>({
  orgUnit:undefined,
  name:'',
  description:''
  })

  useEffect(()=>{
    if(chechStatusSubmitAndUpdate === 'update'){
      setFormData((prev)=>({
        ...prev,
        name:priceBookRow?.pricebookname,
        description:priceBookRow?.description,
        orgUnit:priceBookRow?.OrgId
      }))
    }
  },[chechStatusSubmitAndUpdate,priceBookRow])

  // API call 
  const {mutate:updatePriceBook}  = useUpdatePriceBook();
  const { data: orgUnitsData ,isLoading:orgDataLoading, isSuccess:orgDataSuccess} = useGetOrgUnitsData({ enable: true });
   const{mutate:addPriceBook} = useAddPriceBook();   

   const handleSubmit = (e: React.FormEvent) => {
      e.preventDefault();      
       if(chechStatusSubmitAndUpdate === 'Add'){
        const reqBody = {
          PriceBookName: formData.name ,
          orgUnitId:Number(formData.orgUnit),
          description: formData.description,
        }
       addPriceBook({ReqBody:reqBody})
       handleClose();
    }
    
    else if(chechStatusSubmitAndUpdate ==='update'){
      const reqBody = {
        PriceBookName:formData.name,
        orgUnitId:Number(formData.orgUnit),
        description: formData.description ,
      }
      updatePriceBook({ReqBody:reqBody,id:priceBookRow?.id})
    }
    handleClose();
    };
  
  return (
    <form onSubmit={handleSubmit}>

      <label className="mt-2" style={{ fontWeight: "500" }}>
        Name
      </label>
      <input
       value={formData.name}
        type="text"
        className="form-control"
        onChange={(e)=>setFormData((prev)=>({...prev,name:e.target.value}))}
        style={{
          border: "1px solid #e2e2e2",
          borderRadius: "4px",
          padding: "13px",
          fontSize: "14px",
          width: "100%",
        }}
      />

      {/* Second Dropdown */}
      <ReusableDropdown
        options={!orgDataLoading && orgDataSuccess && orgUnitsData?.data || []} 
        DropdownHeading="Org Unit"
        value={formData.orgUnit}
        onChange={(selectOption:any)=>{
          setFormData((prev)=>({
            ...prev,
            orgUnit:selectOption
          }))
        }}
      />

      {/* Second Input */}
      <label className="mt-2" style={{ fontWeight: "500" }}>
        Description<span style={{color:'red'}}>*</span>
      </label>
      <input
        required
        type="text"
        placeholder="Enter description"
        className="form-control"
        value={formData.description}
        onChange={(e) =>setFormData((prev)=>({...prev, description: e.target.value}))}
        style={{
          border: "2px solid #EDEDED",
          borderRadius: "8px",
          padding: "13px",
          fontSize: "14px",
          width: "100%",
        }}
      />

      {/* Buttons */}
      <div className="d-flex justify-content-start mt-3 gap-2">
        <Btn
          style={{ backgroundColor: "#43B9B2", color: "white" }}
          type="submit"
        >
          Submit
        </Btn>
        <Btn
          style={{
            backgroundColor: "#F9FAFC",
            color: "#000",
            border: "1px solid #E0E0E0",
          }}
          type="button"
          onClick={handleClose}
        >
          Cancel
        </Btn>
      </div>
    </form>
  );
};

export default PriceBooksModalContent;
